import { AstraParagraph, DATE_TEMPLATES, day, format } from '~/astra'
import { BaseStatusData } from '~/hooks/tanstack-query/betterstack/utils'
import { getTimeStampText } from '~/utils/getTimeStampText'

type Props = BaseStatusData & { startsAt?: string; endsAt?: string }

export const BannerText = ({ title, latestUpdateMessage, latestUpdateTimestamp, startsAt, endsAt }: Props) => {
    const dateRangeText =
        startsAt && endsAt ? `[${format(day(startsAt), DATE_TEMPLATES.compactDateTime)} - ${format(day(endsAt), DATE_TEMPLATES.compactDateTime)}]` : ''

    return (
        <div className="flex w-full items-center justify-between gap-2">
            <div className="flex gap-2">
                <AstraParagraph weight="strong">{title}</AstraParagraph>
                {dateRangeText && <AstraParagraph>{dateRangeText}</AstraParagraph>}
                {latestUpdateMessage && <AstraParagraph>{latestUpdateMessage}</AstraParagraph>}
            </div>
            {latestUpdateTimestamp && <AstraParagraph variant="body-small">{`Sist oppdatert: ${getTimeStampText(latestUpdateTimestamp)}`}</AstraParagraph>}
        </div>
    )
}
